import { Component } from '@angular/core';
import { GameResultDataService } from './services/game-result-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

constructor(public data: GameResultDataService){}

}
